import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('millennium_admin_token');

  useEffect(() => {
    if (!token) {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate, token]);

  const signOut = () => {
    localStorage.removeItem('millennium_admin_token');
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-black text-white lg:flex">
      <AdminSidebar />
      <div className="flex min-h-screen flex-1 flex-col">
        <AdminHeader title="Admin Dashboard" subtitle="Manage rental and property listing content." onSignOut={signOut} />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
